import(/* webpackMode: "eager" */ "/vercel/path0/src/app/tr/blog/botoks-yan-etkileri/page.tsx");
